import {
  NOT
} from '../../Boolean.lib';
import Core from '../../Core';
import globalErrorHandler from '../../Error/globalErrorHandler.fun';
import Http from '../../Http';
import {
  Obj
} from '../../Object.lib';
import {
  compileText,
  trim
} from '../../String.lib';
import {
  COLLECTION__ACCOUNTS,
  COLLECTION__CANDIDATES,
  COLLECTION__EMPLOYERS,
  COLLECTION__ENGAGEMENTS,
  COLLECTION__JOBS
} from './loopback.api';

export default async function countLoopbackRecord({
  collection = '',
  where = undefined,
  where: propsWhere = undefined,
  mapper = undefined,
  ...rest
}) {
  where = Obj(where);
  if (
    NOT(trim(collection)) ||
    (
      (propsWhere !== false) &&
      NOT(trim(collection).includes('/')) &&
      NOT(Object.keys(where).length) &&
      [
        COLLECTION__ACCOUNTS,
        COLLECTION__EMPLOYERS,
        COLLECTION__JOBS,
        COLLECTION__CANDIDATES,
        COLLECTION__ENGAGEMENTS
      ].includes(collection)
    )
  ) {
    globalErrorHandler(compileText(
      'Count{{KEY}} - Collection and where parameters are required',
      { KEY: rest.key ? `(${rest.key})` : '' }
    ));
    return null;
  }

  return Http.get(`${Core.getApi(collection)}/count`, {
    ...rest,
    where: JSON.stringify(where)
  })
    .then((response) => {
      let count = response?.count ?? 0;
      if (mapper instanceof Function) {
        count = mapper(count, response);
      }
      return count;
    })
    .catch((error) => {
      globalErrorHandler(error);
      return 0;
    });
}
